module.exports = __webpack_public_path__ + "static/img/edelman.2dd292c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/edelman.svg
// module id = DSO0
// module chunks = 1